import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[header-left]',
    standalone: false
})
class HeaderLeftTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) {}

}

@Directive({
    selector: '[header-right]',
    standalone: false
})
class HeaderRightTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) {}

}

export {
  HeaderLeftTemplateDirective,
  HeaderRightTemplateDirective
};

